/* eslint-disable */
import {
  roundedValue,
  map_adc,
  isStr,
  isFunction,
  getStorageItem,
  setStorageItem,
  getChangeOwnershipQuery,
  getBit,
  SOUND_PERMISSION,
  getParticularTimestamp,
  validateValue,
  RESULT_CONFIG_FAILED,
  RESULT_SETTING_FAILED,
  RESULT_PKGWARE_FAILED,
  RESULT_CONFIG_UPDATED,
  RESULT_SCHEDULE_UPDATED,
  RESULT_PKGWARE_UPDATED,
  ANALOG_INPUT,
  DIGITAL_INPUT,
  DIGITAL_OUTPUT,
  TEMPERATURE,
  getOutputBit,
} from '@/js/utils';
import Logger from '@/js/logger';
import {
  pushDevice,
  fetchPkgwareInfo,
  setUserInfo,
} from '@/api/api.APP_TARGET';
import { convertEndianessFromHex, getByteLength } from '@/js/dataConversion';

const ERROR_NONE = process.env.ERROR_NONE;
const ERROR_AUTH_UNAUTHENTICATED = process.env.ERROR_AUTH_UNAUTHENTICATED;
const ERROR_DEVICE_OWN_BY_OTHER = process.env.ERROR_DEVICE_OWN_BY_OTHER;
const ERROR_DEVICE_NOT_FOUND = process.env.ERROR_DEVICE_NOT_FOUND;
const ERROR_CONNECTION_EXCEEDED = process.env.ERROR_CONNECTION_EXCEEDED;
const ERROR_MODBUS_EVENT_EXISTED = process.env.ERROR_MODBUS_EVENT_EXISTED;
const ERROR_MODBUS_ACTION_EXISTED = process.env.ERROR_MODBUS_ACTION_EXISTED;
const ERROR_MODBUS_HMI_EXCEEDED = process.env.ERROR_MODBUS_HMI_EXCEEDED;
const ERROR_DUPLICATE_MODBUS = process.env.ERROR_DUPLICATE_MODBUS;

export default {
  created() {
    this.isMQTTRequested = false;
    this.lastClientList = this.mqttClientList
      ? this.mqttClientList.slice()
      : [];
    this.lastOnlineList = this.mqttOnlineList
      ? this.mqttOnlineList.slice()
      : [];
    this.stateHistory = {};
  },
  data() {
    return {
      isSoundEnabled: this.$store.getters['local/enableSound'],
      //lastUpdate: {}
    };
  },
  computed: {
    sharedViewList() {
      return this.$store.getters['maker/sharedList'];
    },
    deviceCount() {
      return this.$store.getters['device/numOfDevices'];
    },
    mqttClientList() {
      return this.$store.getters['mqtt/clientList'].map((el) => el.dev_id);
    },
    mqttOnlineList() {
      return this.$store.getters['mqtt/clientList']
        .map((el) => el.mac_addr)
        .filter((uid) => this.$store.getters['mqtt/mqttState'](uid));
    },
    fetchedDeviceList() {
      return this.isMQTTConnected
        ? this.$store.getters['ports/fetchedPortsData']
        : [];
    },
    tobeUpdatedList() {
      return this.$store.getters['mqtt/updatedQueueList'].filter((dev) =>
        this.$store.getters['mqtt/mqttState'](dev.dev_id)
      );
    },
    isMQTTConnected() {
      return this.$store.getters['mqtt/mqttConnectionState'];
    },
    isSessionExpired() {
      return this.$store.getters['local/sessionExpired'];
    },
    isMobile() {
      return this.$store.getters['local/isMobile'];
    },
    userInfo() {
      return this.$store.getters['user/userInfo'];
    },
    settingData() {
      return this.$store.getters['ports/settingData'];
    },
    userPreferences() {
      return this.$store.getters['user/userPreferences'];
    },
    sortedDeviceList() {
      return this.$store.getters['device/sortedDevices'](
        this.$store.getters['local/sortby']
      );
    },
    awaitingDevices() {
      return (this.sortedDeviceList || []).filter(
        (el) => !this.$store.getters['ports/portsData'](el.dev_id)
      );
      //.map((el) => el.dev_id);
    },
    alarmingEvents() {
      return this.$store.getters['mqtt/alarmState']();
    },
    alarmingPorts() {
      const filePaths = this.$route.path.split('/');
      const viewId =
        filePaths.length === 3 && filePaths[1] === 'studio'
          ? filePaths[2]
          : null;

      const sharedPorts = this.$store.getters['ports/sharedPortList']
        .filter(
          (port) =>
            viewId &&
            port.viewIds.indexOf(viewId) !== -1 &&
            port.events &&
            port.events.length &&
            port.events.some(
              (evt) =>
                evt.event_enabled && evt.event_action.indexOf('ALARM') !== -1
            )
        )
        .map((p) => ({
          ...p,
          alarm_events: p.events.filter(
            (evt) =>
              evt.event_enabled && evt.event_action.indexOf('ALARM') !== -1
          ),
          mqttData: p.is_modbus
            ? this.$store.getters['mqtt/mqttSlaveData'](
                p.mac_addr,
                p.port_id_dec
              )
            : this.$store.getters['mqtt/mqttPortData'](p.mac_addr, p.port_name),
        }));

      return (this.$store.getters['device/deviceData'] || [])
        .map((el) => this.$store.getters['ports/portsData'](el.mac_addr))
        .filter(
          (dev) =>
            dev &&
            this.$store.getters['mqtt/mqttState'](dev.mac_addr) &&
            dev.ports.some(
              (port) =>
                port.events &&
                port.events.length &&
                port.events.some(
                  (evt) =>
                    evt.event_enabled &&
                    evt.event_action.indexOf('ALARM') !== -1
                )
            )
        )
        .map((dev) =>
          dev.ports
            .filter(
              (port) =>
                port.events &&
                port.events.length &&
                port.events.some(
                  (evt) =>
                    evt.event_enabled &&
                    evt.event_action.indexOf('ALARM') !== -1
                )
            )
            .map((p) => ({
              ...p,
              mac_addr: dev.mac_addr,
              alarm_events: p.events.filter(
                (evt) =>
                  evt.event_enabled && evt.event_action.indexOf('ALARM') !== -1
              ),
              // event_alarms: this.$store.getters['mqtt/alarmState']({ mac_addr: dev.mac_addr, port_name: p.port_name }),
              mqttData: p.is_modbus
                ? this.$store.getters['mqtt/mqttSlaveData'](
                    dev.mac_addr,
                    p.port_id_dec
                  )
                : this.$store.getters['mqtt/mqttPortData'](
                    dev.mac_addr,
                    p.port_name
                  ),
            }))
        )
        .reduce((flat, next) => flat.concat(next), [])
        .concat(sharedPorts);
    },
  },
  methods: {
    registerAwsCredentials() {
      if (process.env.NODE_ENV === 'development') {
        return;
      }
      AWS.config.region = process.env.AWS_CONFIG_REGION;
      let sollaeCloudToken;
      try {
        sollaeCloudToken = JSON.parse(
          getStorageItem(process.env.ACCESS_TOKEN_KEY)
        );
      } catch (err) {
        sollaeCloudToken = null;
      }
      const access_token = sollaeCloudToken ? sollaeCloudToken.id_token : '';
      AWS.config.region = process.env.AWS_CONFIG_REGION;

      const login = {};
      login[
        process.env.AWS_COGNITO_LOGIN_KEY + process.env.AWS_COGNITO_USER_POOL_ID
      ] = access_token;

      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.COGNITO_IDENTITY_POOL_ID,
        Logins: login,
      });

      return new Promise((resolve, reject) => {
        AWS.config.credentials.refresh((error) => {
          Logger.error('AWS credentials refresh Error', error);
          AWS.config.credentials.get((err) => {
            if (err) {
              Logger.error('AWS credentials Error', err);
              reject(err);
            } else {
              new AWS.Iot().attachPrincipalPolicy(
                {
                  policyName: process.env.AWS_POLICY_NAME,
                  principal: AWS.config.credentials.identityId,
                },
                (err, data) => {
                  if (err) {
                    Logger.error('AWS attachPrincipalPolicy Error', err);
                    reject(err);
                  } else {
                    resolve(data);
                  }
                }
              );
            }
          });
        });
      });
    },
    getUserAPI() {
      return this.$store.dispatch('user/getUserData');
    },
    updateUserInfo(params, callbackFunctions) {
      if (this.isSessionExpired) return;
      const { onSuccessCb, onFailureCb, onFailureMsg } =
        callbackFunctions || {};
      this.$progressBar.show();
      const infoObject = Object.assign({}, this.userInfo);
      return setUserInfo(Object.assign(infoObject, params))
        .then((ret) => this.$store.dispatch('user/setUserData', ret))
        .then(
          () => {
            this.$progressBar.hide();
            this.$toast.showInfo({ content: [this.$t('DIALOG.str67')] });
            if (isFunction(onSuccessCb)) onSuccessCb();
          },
          (errorMsg) => {
            if (isFunction(onFailureCb)) onFailureCb(errorMsg);
            this.handleAPIReject(errorMsg, onFailureMsg);
          }
        );
    },
    retrieveLogData({ dev_id, date, isForce, onSuccessCb, onFailureCb }) {
      return this.$store
        .dispatch('ports/getLogData', {
          dev_id,
          date,
          is_forced: isForce === true,
        })
        .then(
          () => {
            if (isFunction(onSuccessCb)) onSuccessCb();
          },
          (errorMsg) => {
            if (isFunction(onFailureCb)) onFailureCb();
            this.handleAPIReject(errorMsg);
          }
        );
    },
    retrieveLogDownloadLink(dev_id, callbackFunctions) {
      const { onSuccessCb, onFailureCb } = callbackFunctions || {};
      const devInfo = this.$store.getters['ports/portsData'](dev_id);
      if (!devInfo) {
        if (isFunction(callback)) callback();
        return;
      }
      this.$store.dispatch('ports/getLogDownloadLink', { dev_id }).then(
        (responseData) => {
          // this.$progressBar.hide();
          // this.$toast.showInfo({ content: [this.$t('DIALOG.str67')] });
          if (isFunction(onSuccessCb)) onSuccessCb(responseData);
        },
        (errorMsg) => {
          if (isFunction(onFailureCb)) onFailureCb(errorMsg);
          // this.handleAPIReject(errorMsg);
        }
      );
      /* .then(
          (url) => {
            if (url) {
              if (url.download) {
                const link = document.createElement('a');
                link.href = url.download;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else {
                this.$toast.showWarning({
                  content: [devInfo.dev_nickname, 'Device log not found!'],
                });
              }
            }
          },
          (res) => {
            this.handleAPIReject(res);
          }
        ) */
      /*
        .then(() => {
          if (isFunction(callback)) callback();
        });
        */
    },
    addModbusSlave({ dev_id, payload }, callbackFunctions) {
      const { onSuccessCb, onFailureCb, onFailureMsg } =
        callbackFunctions || {};
      this.$store
        .dispatch('ports/addModbusSlaveConfig', {
          dev_id,
          data: payload,
        })
        .then(
          () => {
            this.$progressBar.hide();
            this.$toast.showInfo({ content: ['Modbus Query Added!'] });
            if (isFunction(onSuccessCb)) onSuccessCb();
          },
          (errorMsg) => {
            if (isFunction(onFailureCb)) onFailureCb(errorMsg);
            this.handleAPIReject(errorMsg, onFailureMsg);
          }
        );
    },
    editModbusSlave({ port_id, dev_id, payload }, callbackFunctions) {
      const { onSuccessCb, onFailureCb, onFailureMsg } =
        callbackFunctions || {};
      this.$store
        .dispatch('ports/changeModbusSlaveConfig', {
          dev_id,
          port_id,
          data: payload,
        })
        .then(
          () => {
            this.$toast.showInfo({
              content: ['Modbus Query Updated!'],
            });

            if (isFunction(onSuccessCb)) onSuccessCb();
          },
          (errorMsg) => {
            if (isFunction(onFailureCb)) onFailureCb(errorMsg);
            this.handleAPIReject(errorMsg, onFailureMsg);
          }
        );
    },
    removeModbusSlave({ port_id, dev_id }, callbackFunctions) {
      const { onSuccessCb, onFailureCb, onFailureMsg } =
        callbackFunctions || {};
      this.$store
        .dispatch('ports/deleteModbusSlaveConfig', {
          dev_id,
          port_id,
        })
        .then(
          () => {
            this.$toast.showInfo({
              content: ['Modbus Query Removed!'],
            });
            if (isFunction(onSuccessCb)) onSuccessCb();
          },
          (errorMsg) => {
            if (isFunction(onFailureCb)) onFailureCb(errorMsg);
            this.handleAPIReject(errorMsg, onFailureMsg);
          }
        );
    },
    retrieveDeviceListAPI(deviceList) {
      return this.$store
        .dispatch('device/clearDeviceData')
        .then(() =>
          deviceList
            ? this.$store.dispatch('device/setDeviceData', deviceList)
            : this.getDeviceListAPI()
        )
        .then(() => {
          if (this.awaitingDevices.length) {
            this.getPortGroupDataAPI(this.awaitingDevices);
          }
        });
    },
    getDeviceListAPI() {
      return this.$store.dispatch('device/getDeviceData');
    } /*
        getLatestDeviceList(callbackFunctions) {
          const { onSuccessCb, onFailureCb, onFailureMsg } = callbackFunctions || {};
          return this.retrieveDeviceListAPI()
          .then(() => {
            if (isFunction(onSuccessCb)) onSuccessCb()
          }, (errorMsg) => {
            if (isFunction(onFailureCb)) onFailureCb(errorMsg)
            this.handleAPIReject(errorMsg, onFailureMsg);
          })
        }, */,
    getPortGroupDataAPI(list, callbackFunctions) {
      const { onSuccessCb, onFailureCb, onFailureMsg, noMqttCb } =
        callbackFunctions || {};
      if (!this.isMQTTRequested && !noMqttCb) this.requestMQTT();

      return (
        this.$store
          .dispatch(
            'ports/getPortGroup',
            list.map((el) => ({ dev_id: el.dev_id, dev_model: el.dev_model }))
          )
          .then((queryList) => {
            if (queryList.length)
              return this.$store.dispatch(
                'device/updateDeviceData',
                queryList.map((clientID) =>
                  this.$store.getters['ports/portsData'](clientID)
                )
              );
          })
          /*.then(() => {
          list.forEach((dev) => {
            if (dev.dev_model.toLowerCase().indexOf('smg') !== -1)
              // To be updated
              return this.$store.dispatch(
                'ports/getModbusSlaveConfig',
                dev.dev_id
              );
          });
        }) */
          .then(
            () => {
              if (isFunction(onSuccessCb)) onSuccessCb();
            },
            (errorMsg) => {
              if (isFunction(onFailureCb)) onFailureCb(errorMsg);
              this.handleAPIReject(errorMsg, onFailureMsg);
            }
          )
      );
    },
    getPortsDataAPI({ dev_model, dev_id }, callbackFunctions) {
      const { onSuccessCb, onFailureCb, onFailureMsg } =
        callbackFunctions || {};
      if (!this.isMQTTRequested) this.requestMQTT();
      return (
        this.$store
          .dispatch('ports/getPortsData', { dev_model, dev_id })
          .then(() =>
            this.$store.dispatch('device/updateDeviceData', [
              this.$store.getters['ports/portsData'](dev_id),
            ])
          )
          /*.then(() => {
          if (dev_model.toLowerCase().indexOf('smg') !== -1)
            // To be updated
            return this.$store.dispatch('ports/getModbusSlaveConfig', dev_id);
        }) */
          .then(
            () => {
              if (isFunction(onSuccessCb)) onSuccessCb();
            },
            (errorMsg) => {
              if (isFunction(onFailureCb)) onFailureCb(errorMsg);
              this.handleAPIReject(errorMsg, onFailureMsg);
            }
          )
      );
    } /*
        retrievePortsDataAPI(clientID, callbackFunctions) {
          const { onSuccessCb, onFailureCb, onFailureMsg } = callbackFunctions || {};
          if (!this.isMQTTRequested) this.requestMQTT();
    
          return this.$store.dispatch('ports/clearPortsData', clientID)
          .then(() => this.$store.dispatch('ports/getPortsData', clientID))
          .then(() => { this.$store.dispatch('device/updateDeviceData', [this.$store.getters['ports/portsData'](clientID)])})
          .then(() => {
            if (isFunction(onSuccessCb)) onSuccessCb()
          }, (errorMsg) => {
            if (isFunction(onFailureCb)) onFailureCb(errorMsg)
            this.handleAPIReject(errorMsg, onFailureMsg)
          })
        },
        showLoginRequired() {
            const params = {
              title: this.$t('DIALOG.str16'),
              content: [this.$t('DIALOG.str44')],
              btnConfirm: this.$t('DIALOG.str13'),
              btnCancel: this.$t('DIALOG.str11'),
              onConfirm: () => {
                location.replace('/login/google')
              }
            }
            this.$modal.show(params);
        }, */,
    handleMQTTDisconnect(err) {
      Logger.warn('MQTT Closing', err);
      this.$store.dispatch('mqtt/stopConnection');
      this.$footerMsg.set({
        errMsg: this.$t('DIALOG.str03'),
        errBtn: this.$t('DIALOG.str30'),
        errReload: true,
        priority: 1,
      });
      this.$progressBar.hide();
      /*
      const params = {
        title: this.$t('DIALOG.str03'),
        content: [this.$t('DIALOG.str30')],
        btnConfirm: this.$t('DIALOG.str14'),
        btnCancel: this.$t('DIALOG.str25'),
        onCancel: () => { this.$progressBar.hide() },
        onConfirm: () => { location.href = '' } //this.$store.dispatch('mqtt/setMqttClient')
      };

      this.$modal.show(params);
      */
    },
    getMqttAPI() {
      Logger.info('Init MQTT Client');
      const awsCredentials = this.registerAwsCredentials();
      if (!awsCredentials) {
        Logger.warn('MQTT Connection Failed');
        return;
      }
      return awsCredentials.then(() =>
        this.$store.dispatch('mqtt/setMqttClient', {
          onConnectCallback: () => {
            this.$store.dispatch('mqtt/startConnection');
            this.$store.dispatch(
              'mqtt/subscribeDownloadTopic',
              this.$store.getters['user/downloadTopic']
            );
            Logger.info('MQTT Connected');
            if (
              !this.isSoundEnabled &&
              getBit(this.userPreferences, SOUND_PERMISSION) &&
              !this.isMobile
            ) {
              const params = {
                title: this.$t('DIALOG.str70'),
                content: [this.$t('DIALOG.str71'), this.$t('DIALOG.str72')],
                btnConfirm: this.$t('DIALOG.str13'),
                btnCancel: this.$t('DIALOG.str25'),
                onConfirm: () => {
                  this.$alarmSound.set(true);
                },
                onCancel: () => {
                  this.$toast.showInfo({
                    content: [this.$t('DIALOG.str65'), this.$t('DIALOG.str62')],
                  });
                },
              };
              this.$modal.show(params);
            }
          },
          onConnectionLostCallback: (errorMsg) => {
            this.handleMQTTDisconnect(errorMsg);
            console.log('MQTT Disconnected', errorMsg);
          },
          onMessageArrivedCallback: (destinationName, payloadString) => {
            this.$store
              .dispatch('mqtt/setMqttData', {
                destinationName,
                payloadString,
              })
              .catch((errorMsg) => {
                this.handleAPIReject(errorMsg);
                Logger.error(errorMsg);
              });
          },
          onFailureCallback: (err) => this.handleMQTTDisconnect(err),
        })
      );
    },
    requestMQTT() {
      if (!this.isMQTTRequested) {
        this.isMQTTRequested = true;
        const awsRequest = this.getMqttAPI();
        if (!awsRequest) {
          Logger.warn('MQTT Request Failed');
          return;
        }
        awsRequest.catch((errorMsg) => {
          this.handleAPIReject(errorMsg);
        });
      }
    },
    handleAPIReject(errorMsg, onFailureMsg) {
      Logger.warn(errorMsg);
      this.$progressBar.hide();
      if (isStr(errorMsg.message)) {
        if (errorMsg.message.indexOf('401') !== -1) {
          if (this.$store.getters['user/userEmail']) {
            //this.showLoginRequired();
            this.$footerMsg.set({
              errMsg: this.$t('DIALOG.str16'),
              errBtn: this.$t('DIALOG.str44'),
              errLink: this.$t('LINKS.str04'),
              priority: 3,
            });
            this.$store.dispatch('local/setSessionExpired');
          } else {
            this.$toast.showWarning({
              content: [
                this.$t('DIALOG.str69'),
                this.$t('DIALOG.str68'),
                'ERROR_CODE: ' + errorMsg.message,
              ],
            });
            setTimeout(() => {
              if (
                window.location.pathname.startsWith('/studio/') ||
                window.location.pathname.startsWith('/dashboard/')
              ) {
                setStorageItem(
                  process.env.LAST_URL_KEY,
                  window.location.pathname
                );
                return location.replace(process.env.SIGNIN_URL);
              }
              location.replace(this.$t('LINKS.str04'));
            }, 2000);
          }
          return;
        }
        switch (
          errorMsg.message.slice(errorMsg.message.length - 2).toLowerCase()
        ) {
          case ERROR_NONE:
            return;
          case ERROR_AUTH_UNAUTHENTICATED:
            if (this.$store.getters['user/userEmail']) {
              //this.showLoginRequired();
              this.$footerMsg.set({
                errMsg: this.$t('DIALOG.str16'),
                errBtn: this.$t('DIALOG.str44'),
                errLink: this.$t('LINKS.str03'),
                priority: 3,
              });
              this.$store.dispatch('local/setSessionExpired');
            } else {
              this.$toast.showWarning({
                content: [
                  this.$t('DIALOG.str69'),
                  this.$t('DIALOG.str68'),
                  'ERROR_CODE: ' + errorMsg.message,
                ],
              });
              setTimeout(() => {
                if (
                  window.location.pathname.startsWith('/studio/') ||
                  window.location.pathname.startsWith('/dashboard/')
                ) {
                  setStorageItem(
                    process.env.LAST_URL_KEY,
                    window.location.pathname
                  );
                  return location.replace(process.env.SIGNIN_URL);
                }
                location.replace(this.$t('LINKS.str03'));
              }, 2000);
            }
            return;
          case ERROR_DEVICE_NOT_FOUND:
            this.$toast.showAlert({
              content: [
                this.$t('DIALOG.str80'),
                'ERROR_CODE: ' + errorMsg.message,
              ],
            });
            return;
          case ERROR_CONNECTION_EXCEEDED:
            this.$footerMsg.set({
              errMsg: `${this.$t('DIALOG.str10')} (${
                this.$store.getters['user/maxConn']
              })`,
              errBtn: this.$t('DIALOG.str30'),
              errReload: true,
              priority: 1,
            });
            return;
          case ERROR_DEVICE_OWN_BY_OTHER:
            this.$toast.showAlert({
              content: [
                this.$t('DIALOG.str81'),
                'ERROR_CODE: ' + errorMsg.message,
              ],
            });
            return;
          case ERROR_MODBUS_EVENT_EXISTED:
            this.$toast.showAlert({
              content: [
                this.$t('SETTING.queryWarn1'),
                this.$t('SETTING.queryWarn2'),
                'ERROR_CODE: ' + errorMsg.message,
              ],
            });
            return;
          case ERROR_MODBUS_ACTION_EXISTED:
            this.$toast.showAlert({
              content: [
                this.$t('SETTING.queryWarn1'),
                this.$t('SETTING.queryWarn3'),
                'ERROR_CODE: ' + errorMsg.message,
              ],
            });
            return;
          case ERROR_DUPLICATE_MODBUS:
            this.$toast.showAlert({
              content: [
                this.$t('SETTING.queryDup'),
                'ERROR_CODE: ' + errorMsg.message,
              ],
            });
            return;
          case ERROR_MODBUS_HMI_EXCEEDED:
            this.$toast.showAlert({
              content: [
                this.$t('SETTING.queryLimRes'),
                'ERROR_CODE: ' + errorMsg.message,
              ],
            });
            return;
        }
      }
      const alertContent = (
        onFailureMsg instanceof Array
          ? onFailureMsg
          : [this.$t(onFailureMsg || 'DIALOG.str04')]
      ).concat(['ERROR_CODE: ' + errorMsg.message]);
      this.$toast.showAlert({ content: alertContent });
    },
    initUserDeviceList(params) {
      const { onFailureMsg, onFailureCb, noMqttCb } = params || {};
      return this.getUserAPI()
        .then(() => this.getDeviceListAPI())
        .then(() => {
          if (this.awaitingDevices.length) {
            this.getPortGroupDataAPI(this.awaitingDevices, { noMqttCb });
          }
        })
        .catch((errorMsg) => {
          if (isFunction(onFailureCb)) onFailureCb(errorMsg);
          // this.handleAPIReject(errorMsg, onFailureMsg);
        });
    } /*
        initFullData(params) {
          const { onSuccessCb, onFailureCb, onFailureMsg } = params || {};
          return this.retrieveDeviceListAPI()
          .then(() => this.retrieveDeviceListAPI())
          .then(() => this.retrieveAllPortGroupAPI())
          .then(() => {
            if (isFunction(onSuccessCb)) onSuccessCb()
          }, (errorMsg) => {
            if (isFunction(onFailureCb)) onFailureCb(errorMsg);
            this.handleAPIReject(errorMsg, onFailureMsg)
          })
      }, */,
    getIncreasedDeviceList(clientID) {
      this.$progressBar.show();
      return pushDevice(getChangeOwnershipQuery(clientID))
        .then((data) => this.retrieveDeviceListAPI())
        .then(
          () => {
            this.$progressBar.hide();
            this.$toast.showInfo({
              content: [this.$t('DIALOG.str56'), clientID],
            });
          },
          (errorMsg) => {
            this.handleAPIReject(errorMsg);
          }
        );
    },
    getDecreasedDeviceList({ dev_id }) {
      this.$progressBar.show();
      return this.$store
        .dispatch('device/deregisterDevice', { dev_id })
        .then(() =>
          this.$store.dispatch('mqtt/clearDeregisteredDevice', dev_id)
        )
        .catch((errorMsg) => {
          this.handleAPIReject(errorMsg);
        });
    },
    loadMqttInfo(devID) {
      if (devID) {
        const data = this.$store.getters['ports/portsData'](devID);
        return this.$store.dispatch('mqtt/setClientInfo', data).then(() => {
          this.$store.dispatch('mqtt/subscribeMqttData', { uid: devID });
        });
      }
    },
    getPkgwareInfo({ devId, callback }) {
      const devInfo = this.$store.getters['ports/portsData'](devId);
      if (!devInfo) {
        if (isFunction(callback)) callback();
        return;
      }
      const deviceName = devInfo.dev_nickname;
      return fetchPkgwareInfo(devId)
        .then(
          (res) => {
            // console.log(res)
            if (res.new) {
              const params = {
                title: deviceName,
                content: [
                  this.$t('DIALOG.str07'),
                  res.current + ' → ' + res.latest,
                  this.$t('DIALOG.str08'),
                ],
                btnConfirm: this.$t('DIALOG.str15'),
                btnCancel: this.$t('DIALOG.str11'),
                onConfirm: () =>
                  this.sendPkgwareRequest({
                    dev_id: devId,
                    latest: res.latest,
                    host_name: res.host_name,
                    host_port: res.host_port,
                    uri_path: res.uri_path,
                  }),
              };
              this.$modal.show(params);
            } else {
              const params = {
                title: deviceName,
                content: [this.$t('DIALOG.str06'), res.latest],
                btnConfirm: this.$t('DIALOG.str13'),
              };
              this.$modal.show(params);
            }
          },
          (res) => {
            this.handleAPIReject(res);
          }
        )
        .then(() => {
          if (isFunction(callback)) callback();
        });
    },
    sendPkgwareRequest(params) {
      this.$progressBar.show();
      return this.$store
        .dispatch('mqtt/sendFwRequest', params)
        .catch((res) => this.handleAPIReject(res));
    },
    getDeviceName(devId) {
      const device = this.$store.getters['ports/portsData'](devId);
      return device ? device.dev_nickname : '';
    },
    getDeviceModel(devId) {
      const device = this.$store.getters['ports/portsData'](devId);
      return device ? device.dev_model : null;
    },
    checkAlarm(evt, params) {
      if (params.currCount != null && params.prevCount == null) {
        if (evt.json_keys || evt.event_condition === '==') return false;
      }

      if (params.currVal == null) return false;

      const latestVal = params.currVal;
      const prevVal = params.prevVal;
      const hysteresis = parseFloat(evt.event_noise) || 0;
      const threshold = Number(evt.event_value);
      const latestCount = params.currCount;
      const prevCount = params.prevCount;

      let latestState, isActived;
      const eventInfos = (evt.json_keys || '').split('->');
      const portType = eventInfos[0]
        ? eventInfos[0].substr(0, eventInfos[0].length - 1).toUpperCase()
        : evt.event_condition === '<=' || evt.event_condition === '>='
        ? ANALOG_INPUT
        : DIGITAL_INPUT;
      // const category = params[1]
      switch (portType) {
        case ANALOG_INPUT:
        case TEMPERATURE:
          if (evt.event_condition === '<=') {
            latestState =
              latestVal <= threshold
                ? false
                : latestVal > threshold + hysteresis
                ? true
                : null;
            if (prevVal == null) {
              if (
                latestState != null &&
                evt.last_digital_state !== latestState
              ) {
                evt.last_digital_state = latestState;
              }
              return false;
            }
            isActived =
              latestState === false && evt.last_digital_state === true;

            if (
              evt.last_digital_state == null ||
              evt.last_threshold !== threshold ||
              evt.last_condition !== evt.event_condition
            ) {
              evt.last_digital_state = latestVal > threshold;
              evt.last_threshold = threshold;
              evt.last_condition = evt.event_condition;
            } else if (
              latestState != null &&
              evt.last_digital_state !== latestState
            ) {
              evt.last_digital_state = latestState;
            }

            return isActived;
          } else if (evt.event_condition === '>=') {
            latestState =
              latestVal >= threshold
                ? true
                : latestVal < threshold - hysteresis
                ? false
                : null;

            if (prevVal == null) {
              if (
                latestState != null &&
                evt.last_digital_state !== latestState
              ) {
                evt.last_digital_state = latestState;
              }
              return false;
            }
            isActived =
              latestState === true && evt.last_digital_state === false;
            if (
              evt.last_digital_state == null ||
              evt.last_threshold !== threshold ||
              evt.last_condition !== evt.event_condition
            ) {
              evt.last_digital_state = latestVal >= threshold;
              evt.last_threshold = threshold;
              evt.last_condition = evt.event_condition;
            } else if (
              latestState != null &&
              evt.last_digital_state !== latestState
            )
              evt.last_digital_state = latestState;

            return isActived;
          }
        case DIGITAL_INPUT:
        case DIGITAL_OUTPUT:
          if (prevVal == null) {
            return false;
          }
          if (evt.event_condition === '==') {
            return evt.event_value === 0
              ? !latestVal && prevVal
              : latestVal && !prevVal;
          } else if (evt.event_condition === '<=') {
            return latestCount <= threshold && prevCount > threshold;
          } else if (evt.event_condition === '>=') {
            return latestCount >= threshold && prevCount < threshold;
          }
      }
      /*switch (evt.event_condition) {
        case 'FALLING':
          return !latestVal && prevVal;
        case 'RISING':
          return latestVal && !prevVal;
        case '<=':
          latestState =
            latestVal <= threshold
              ? false
              : latestVal > threshold + hysteresis
              ? true
              : null;
          isActived = latestState === false && evt.last_digital_state === true;

          if (
            evt.last_digital_state == null ||
            evt.last_threshold !== threshold ||
            evt.last_condition !== evt.event_condition
          ) {
            evt.last_digital_state = latestVal > threshold;
            evt.last_threshold = threshold;
            evt.last_condition = evt.event_condition;
          } else if (
            latestState != null &&
            evt.last_digital_state !== latestState
          )
            evt.last_digital_state = latestState;

          return isActived;
        case '>=':
          latestState =
            latestVal >= threshold
              ? true
              : latestVal < threshold - hysteresis
              ? false
              : null;
          isActived = latestState === true && evt.last_digital_state === false;

          if (
            evt.last_digital_state == null ||
            evt.last_threshold !== threshold ||
            evt.last_condition !== evt.event_condition
          ) {
            evt.last_digital_state = latestVal >= threshold;
            evt.last_threshold = threshold;
            evt.last_condition = evt.event_condition;
          } else if (
            latestState != null &&
            evt.last_digital_state !== latestState
          )
            evt.last_digital_state = latestState;

          return isActived;
        case 'CNT<=':
          return latestCount <= threshold && prevCount > threshold;
        case 'CNT>=':
          return latestCount >= threshold && prevCount < threshold;
      } */
    },
    checkPassedAlarm(evt, params) {
      if (params.prevVal == null) return false;

      const latestVal = params.currVal;
      const latestCount = params.currCount;
      const hysteresis = parseFloat(evt.event_noise) || 0;
      const threshold = Number(evt.event_value);
      const eventInfos = (evt.json_keys || '').split('->');
      const portType = eventInfos[0]
        ? eventInfos[0].substr(0, eventInfos[0].length - 1).toUpperCase()
        : evt.event_condition === '<=' || evt.event_condition === '>='
        ? ANALOG_INPUT
        : DIGITAL_INPUT;
      switch (portType) {
        case ANALOG_INPUT:
        case TEMPERATURE:
          return evt.event_condition === '<='
            ? latestVal > threshold + hysteresis
            : latestVal < threshold - hysteresis;
        case DIGITAL_INPUT:
        case DIGITAL_OUTPUT:
          if (evt.event_condition === '==') {
            return evt.event_value === 0 ? latestVal : !latestVal;
          }
          return evt.event_condition === '<='
            ? latestCount > threshold
            : latestCount < threshold;
      }
      /*
      switch (evt.event_condition) {
        case 'FALLING':
          return latestVal;
        case 'RISING':
          return !latestVal;
        case '<=':
          return latestVal > threshold + hysteresis;
        case '>=':
          return latestVal < threshold - hysteresis;
        case 'CNT<=':
          return latestCount > threshold;
        case 'CNT>=':
          return latestCount < threshold;
      }
      */
    },
    getModbusSlaveSetting(dev_id, callbackFunctions) {
      const { onFailureCb, onFailureMsg } = callbackFunctions || {};
      this.$store
        .dispatch('ports/getModbusSlaveConfig', dev_id)
        .catch((errorMsg) => {
          if (isFunction(onFailureCb)) onFailureCb(errorMsg);
          this.handleAPIReject(errorMsg, onFailureMsg);
        });
    },
    updateModbusSetting({ dev_model, dev_id, data }) {
      this.$progressBar.show();
      this.$store
        .dispatch('ports/changeModbusConfig', {
          dev_model,
          dev_id,
          data,
        })
        .then(() =>
          this.$store.dispatch('device/updateDeviceData', [
            this.$store.getters['ports/portsData'](dev_id),
          ])
        )
        .then(
          () => {
            this.$toast.showInfo({
              content: [this.getDeviceName(dev_id), , this.$t('DIALOG.str21')],
            });
          },
          (errorMsg) => {
            this.handleAPIReject(errorMsg);
          }
        )
        .then(() => this.$progressBar.hide());
    },
    updateDeviceSetting({ dev_id, data, suppressToast }) {
      this.$progressBar.show();
      const dev_model =
        this.$store.getters['ports/portsData'](dev_id).dev_model;
      this.$store
        .dispatch('ports/sendSettingData', data)
        .then((savingResponse) => {
          if (Array.isArray(savingResponse)) {
            const errorResponses = savingResponse.reduce((errors, res) => {
              const body =
                typeof res.body === 'string' ? JSON.parse(res.body) : res.body;
              if (body?.error) {
                errors.push({
                  ...res,
                  body: body,
                });
              }
              return errors;
            }, []);

            const allErrors = errorResponses.length === savingResponse.length;
            if (allErrors) {
              throw {
                message:
                  errorResponses[0].body.error.code || errorResponses[0].status,
              };
            }

            return this.$store
              .dispatch('ports/clearPortsData', dev_id)
              .then(() => {
                return this.getPortsDataAPI({
                  dev_id,
                  dev_model,
                });
              })
              .then(() => {
                if (errorResponses.length > 0) {
                  throw {
                    message:
                      errorResponses[0].body.error.code ||
                      errorResponses[0].status,
                  };
                }
              });
          }
        })
        .then(
          () => {
            if (!suppressToast) {
              this.$toast.showInfo({
                content: [
                  this.getDeviceName(dev_id),
                  ,
                  this.$t('DIALOG.str21'),
                ],
              });
            }
          },
          (errorMsg) => {
            // Handle API rejection
            this.handleAPIReject(errorMsg);
          }
        )
        .then(() => this.$progressBar.hide());
    },
  },
  watch: {
    /* awaitingDevices: {
      deep: true,
      immediate: true,
      handler() {
        if (this.awaitingDevices.length) {
          this.getPortGroupDataAPI(this.awaitingDevices);
        }
      }
    }, */
    sharedViewList(newList, oldList) {
      if (newList && newList.length && !oldList) {
        if (!this.isMQTTRequested) this.requestMQTT();
      }
    },
    alarmingPorts: {
      deep: true,
      immediate: true,
      handler() {
        this.alarmingPorts.forEach((p) => {
          if (p) {
            if (p.alarm_events.length) {
              if (!p.mqttData.length) return;
              let currVal = '',
                lastVal = '',
                currCount = '',
                lastCount = '',
                dataParams = {};
              const isSecondVal = p.mqttData.length > 1;
              const currMqttVal = p.mqttData[p.mqttData.length - 1];
              const lastMqttVal = p.mqttData[p.mqttData.length - 2];
              switch (p.port_type.toUpperCase()) {
                case TEMPERATURE:
                  currVal = currMqttVal.value;
                  lastVal = isSecondVal ? lastMqttVal.value : null;
                  if (currVal === lastVal) return;
                  dataParams.currVal = validateValue(currVal)
                    ? roundedValue(
                        map_adc(currVal, p.port_min, p.port_max, true),
                        p.dec_place
                      )
                    : null;
                  dataParams.prevVal =
                    isSecondVal && validateValue(lastVal)
                      ? roundedValue(
                          map_adc(lastVal, p.port_min, p.port_max, true),
                          p.dec_place
                        )
                      : null;
                  break;
                case ANALOG_INPUT:
                  if (p.is_modbus) {
                    currVal = currMqttVal.hex_data;
                    lastVal =
                      isSecondVal && lastMqttVal.hex_data != null
                        ? lastMqttVal.hex_data
                        : null;
                  } else {
                    currVal = currMqttVal.value;
                    lastVal = isSecondVal ? lastMqttVal.value : null;
                  }

                  if (currVal == null) return;

                  if (currVal === lastVal) return;

                  if (p.is_modbus) {
                    dataParams.currVal =
                      !currMqttVal.is_timeout &&
                      currMqttVal.rep_func === p.req_func &&
                      getByteLength(p.data_type) * 2 ===
                        currMqttVal.hex_data.length
                        ? roundedValue(
                            convertEndianessFromHex(
                              currVal,
                              p.byte_swap,
                              p.word_swap,
                              p.dword_swap,
                              p.data_type
                            ) *
                              p.rep_scale +
                              p.rep_offset,
                            p.dec_place
                          )
                        : null;

                    dataParams.prevVal =
                      isSecondVal &&
                      !lastMqttVal.is_timeout &&
                      lastMqttVal.rep_func === p.req_func &&
                      getByteLength(p.data_type) * 2 ===
                        lastMqttVal.hex_data.length
                        ? roundedValue(
                            convertEndianessFromHex(
                              lastVal,
                              p.byte_swap,
                              p.word_swap,
                              p.dword_swap,
                              p.data_type
                            ) *
                              p.rep_scale +
                              p.rep_offset,
                            p.dec_place
                          )
                        : null;
                  } else {
                    dataParams.currVal = roundedValue(
                      map_adc(currVal, p.port_min, p.port_max),
                      p.dec_place
                    );
                    dataParams.prevVal = isSecondVal
                      ? roundedValue(
                          map_adc(lastVal, p.port_min, p.port_max),
                          p.dec_place
                        )
                      : null;
                  }
                  break;
                case DIGITAL_INPUT:
                  if (p.is_modbus) {
                    if (currMqttVal.hex_data == null) {
                      return;
                    }
                    currVal = Boolean(
                      getOutputBit(currMqttVal.hex_data, p.port_offset)
                    );
                    lastVal =
                      isSecondVal && lastMqttVal.hex_data != null
                        ? Boolean(
                            getOutputBit(lastMqttVal.hex_data, p.port_offset)
                          )
                        : null;
                    if (currVal == null || lastVal == null) return;

                    dataParams.currVal =
                      !currMqttVal.is_timeout &&
                      currMqttVal.rep_func === p.req_func
                        ? currVal
                        : null;
                    dataParams.prevVal =
                      isSecondVal &&
                      !lastMqttVal.is_timeout &&
                      lastMqttVal.rep_func === p.req_func
                        ? lastVal
                        : null;
                  } else {
                    currVal = currMqttVal.value;
                    lastVal = isSecondVal ? lastMqttVal.value : null;
                    currCount = currMqttVal.count;
                    lastCount = isSecondVal ? lastMqttVal.count : null;
                    if (currVal === lastVal && currCount === lastCount) return;
                    dataParams.currVal = Number(p.relay_mode) ^ currVal;
                    dataParams.prevVal = isSecondVal
                      ? Number(p.relay_mode) ^ lastVal
                      : null;
                    dataParams.currCount = currCount;
                    dataParams.prevCount = lastCount;
                    break;
                  }
                case DIGITAL_OUTPUT:
                  if (p.is_modbus) {
                    if (currMqttVal.hex_data == null) {
                      return;
                    }
                    currVal = Boolean(
                      getOutputBit(currMqttVal.hex_data, p.port_offset)
                    );
                    lastVal =
                      isSecondVal && lastMqttVal.hex_data != null
                        ? Boolean(
                            getOutputBit(lastMqttVal.hex_data, p.port_offset)
                          )
                        : null;
                    if (currVal == null || lastVal == null) return;

                    dataParams.currVal =
                      !currMqttVal.is_timeout &&
                      currMqttVal.rep_func === p.req_func
                        ? currVal
                        : null;
                    dataParams.prevVal =
                      isSecondVal &&
                      !lastMqttVal.is_timeout &&
                      lastMqttVal.rep_func === p.req_func
                        ? lastVal
                        : null;
                  } else {
                    currVal = currMqttVal.value;
                    lastVal = isSecondVal ? lastMqttVal.value : null;
                    if (currVal === lastVal) return;
                    dataParams.currVal = Number(p.relay_mode) ^ currVal;
                    dataParams.prevVal = isSecondVal
                      ? Number(p.relay_mode) ^ lastVal
                      : null;
                  }
                  break;
              }

              const lastData = JSON.stringify(p.mqttData);
              let shouldCheck = false;
              if (this.stateHistory[p.port_id] !== lastData) {
                this.stateHistory[p.port_id] = lastData;
                shouldCheck = true;
              }

              p.alarm_events.forEach((alarmEvent) => {
                const isActivated = this.alarmingEvents.find(
                  (alarm) => alarm.event_id === alarmEvent.event_id
                ); // p.event_alarms.find(alarm => alarm.event_id === alarmEvent.event_id);
                const isAlarm = this.checkAlarm(alarmEvent, dataParams);

                if (isAlarm) {
                  if (!isActivated && shouldCheck) {
                    this.$store.dispatch('mqtt/activateAlarmState', {
                      mac_addr: p.mac_addr,
                      port_name: p.port_name,
                      port_id: p.port_id,
                      event_id: alarmEvent.event_id,
                    });
                  }
                } else if (isActivated) {
                  if (this.checkPassedAlarm(alarmEvent, dataParams))
                    this.$store.dispatch('mqtt/deactivateAlarmState', {
                      mac_addr: p.mac_addr,
                      // port_name: p.port_name,
                      port_id: p.port_id,
                      event_id: alarmEvent.event_id,
                    });
                }
              });
            }
          }
        });

        if (this.alarmingEvents.length) {
          const activatingAlarms = this.alarmingPorts
            .map((p) => p.alarm_events)
            .reduce((flat, next) => flat.concat(next), [])
            .map((evt) => evt.event_id);
          this.alarmingEvents
            .filter((alarm) => activatingAlarms.indexOf(alarm.event_id) === -1)
            .forEach((alm) =>
              this.$store.dispatch('mqtt/deactivateAlarmState', alm)
            );
        }
      },
    },
    mqttClientList: {
      handler() {
        const removedList = this.lastClientList.filter(
          (el) => this.mqttClientList.indexOf(el) === -1
        );
        if (removedList.length) {
          const deviceRemovedList = [];
          removedList.forEach((devID) => {
            const devInfo = this.$store.getters['ports/portsData'](devID);
            deviceRemovedList.push({
              devModel: devInfo.dev_model,
              devName: devInfo.dev_nickname,
              devMAC: devInfo.mac_addr,
              devReg: getParticularTimestamp(devInfo.add_date),
            });
          });

          removedList
            .reduce((sequence, devID) => {
              return sequence.then(() => {
                this.$store.dispatch('ports/removePortsData', devID);
              });
            }, Promise.resolve())
            .then(() => this.retrieveDeviceListAPI())
            .then(
              () => {
                const reduceList = deviceRemovedList
                  .filter(
                    (el) => !this.$store.getters['ports/portsData'](el.devMAC)
                  )
                  .map((item) => [
                    item.devName,
                    `${this.$t('COMMON.str13')}: ${item.devModel}`,
                    `${this.$t('COMMON.str12')}: ${item.devMAC}`,
                    `${this.$t('COMMON.str14')}: ${item.devReg}`,
                  ])
                  .reduce((acc, curr) => acc.concat(curr), []);
                this.$progressBar.hide();
                this.$toast.showInfo({
                  content: [this.$t('DIALOG.str57')].concat(reduceList),
                });
              },
              (errorMsg) => {
                this.handleAPIReject(errorMsg);
              }
            );
        }
        this.lastClientList = this.mqttClientList.slice();
      },
    },
    mqttOnlineList: {
      handler() {
        const offlineList = this.lastOnlineList.filter(
          (el) => this.mqttOnlineList.indexOf(el) === -1
        );
        if (offlineList.length) {
          offlineList.reduce((sequence, macAddr) => {
            return sequence.then(() =>
              this.$store.dispatch('mqtt/clearMqttData', macAddr).then(() => {
                this.$store.dispatch('mqtt/deactivateAlarmState', {
                  mac_addr: macAddr,
                });
                //this.lastUpdate[macAddr] = null;
              })
            );
          }, Promise.resolve());
        }
        this.lastOnlineList = this.mqttOnlineList.slice();
      },
    },
    fetchedDeviceList: {
      immediate: true,
      handler() {
        if (!this.fetchedDeviceList.length) return;

        this.fetchedDeviceList
          .filter((el) => this.mqttClientList.indexOf(el) === -1)
          .reduce((sequence, clientID) => {
            return sequence.then(() => this.loadMqttInfo(clientID));
          }, Promise.resolve());
        //.forEach(dev => this.loadMqttInfo(dev))
      },
    },
    tobeUpdatedList: {
      immediate: true,
      handler() {
        if (!this.tobeUpdatedList.length) return;
        const devId = this.tobeUpdatedList[0].dev_id;
        const result = this.tobeUpdatedList[0].result;
        const devModel = this.getDeviceModel(devId);
        if (!devId || !devModel) return;
        this.$store
          .dispatch('mqtt/reduceSettingUpdate', devId)
          .then(() => this.$store.dispatch('ports/clearPortsData', devId))
          .then(() =>
            this.getPortsDataAPI(
              { dev_id: devId, dev_model: devModel },
              {
                onSuccessCb: () => {
                  this.$progressBar.hide();
                  this.$nextTick().then(() => {
                    switch (result) {
                      case RESULT_PKGWARE_FAILED:
                        this.$toast.showWarning({
                          content: [
                            this.getDeviceName(devId),
                            this.$t('DIALOG.str93'),
                          ],
                        });
                        break;
                      case RESULT_CONFIG_FAILED:
                        this.$toast.showWarning({
                          content: [
                            this.getDeviceName(devId),
                            this.$t('DIALOG.str92'),
                            this.$t('DIALOG.str63'),
                          ],
                        });
                        break;
                      case RESULT_SETTING_FAILED:
                        this.$toast.showWarning({
                          content: [
                            this.getDeviceName(devId),
                            this.$t('DIALOG.str94'),
                            this.$t('DIALOG.str63'),
                          ],
                        });
                        break;
                      case RESULT_CONFIG_UPDATED:
                        if (
                          this.settingData &&
                          this.settingData.dev_id === devId
                        ) {
                          this.$toast.showWarning({
                            content: [
                              this.getDeviceName(devId),
                              this.$t('DIALOG.str21'),
                              this.$t('DIALOG.str84'),
                            ],
                          });
                        } else
                          this.$toast.showInfo({
                            content: [
                              this.getDeviceName(devId),
                              this.$t('DIALOG.str21'),
                            ],
                          });
                        break;
                      case RESULT_SCHEDULE_UPDATED:
                        if (
                          this.settingData &&
                          this.settingData.dev_id === devId
                        ) {
                          this.$toast.showWarning({
                            content: [
                              this.getDeviceName(devId),
                              this.$t('DIALOG.str19'),
                              this.$t('DIALOG.str84'),
                            ],
                          });
                        } else
                          this.$toast.showInfo({
                            content: [
                              this.getDeviceName(devId),
                              this.$t('DIALOG.str19'),
                            ],
                          });
                        break;
                      case RESULT_PKGWARE_UPDATED:
                        this.$toast.showInfo({
                          content: [
                            this.getDeviceName(devId),
                            this.$t('DIALOG.str09'),
                          ],
                        });
                        break;
                    }
                  });
                },
                onFailureMsg: [
                  this.getDeviceName(devId),
                  this.$t('DIALOG.str59'),
                ],
              }
            )
          );
      },
    },
  },
};
